import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
//npm install jsbarcode
export default function Bar_code({ value,code }) {
    const ref = useRef(null);

    useEffect(() => {
        JsBarcode(ref.current, value, {
              format: "CODE128", 
              
            displayValue:code, // set true if you want text under barcode
             fontSize: 18,
            margin: 1,
        });
    }, [value]);

    return <svg ref={ref}></svg>;
}
